const scope = {
    name_exists: 'スコープ名 {{name}} は既に使用されています',
    name_with_space: 'スコープの名前にはスペースを含めることはできません。',
};
export default Object.freeze(scope);
